import { render, staticRenderFns } from "./MoshaverManager.vue?vue&type=template&id=c251a0da&scoped=true&"
import script from "./MoshaverManager.vue?vue&type=script&lang=js&"
export * from "./MoshaverManager.vue?vue&type=script&lang=js&"
import style0 from "./MoshaverManager.vue?vue&type=style&index=0&id=c251a0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c251a0da",
  null
  
)

export default component.exports